<script lang="ts" setup>
import { useSiteStore } from '~/stores/site.store';
import { useAuthStore } from '~/stores/auth.store';
import LazyImage from '../design-system/lazy-image.vue';

const { $marketingService } = useServices();
const site = useSiteStore();
const auth = useAuthStore();
const { logoSets } = useBranding();

onUnmounted(() => {
  if (site.getFeatureFlags.get('website.toastmessages')) {
    $marketingService.fetchToasts();
  }
});
</script>
<template>
  <div
    class="bg-gradient-to-b from-[#6A6B7C] to-[#2F2F37] p-4 my-4 w-[296px] h-[186px] rounded-2xl"
  >
    <div
      class="user-card--content rounded-lg mx-auto w-full h-full flex flex-col justify-between"
    >
      <div class="ml-auto max-w-[140px] w-full">
        <LazyImage
          :key="logoSets.dark"
          fetchpriority="high"
          class="w-auto"
          :src="logoSets.dark"
          alt="Jackpotcity"
        />
      </div>
      <div class="flex justify-between text-light-50 text-xs">
        <div>
          {{ $t('account-no') }}
          <p class="font-bold text-light-50">
            {{
              auth?.currentUser?.primaryMobileNumber?.mobileNumber ||
              $t('unavailable')
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
